<template>
    <div :id="'palette-options-'+palette.id" class="palette-options-wrapper">
        <div class="palette-options">
            <button title="Edit" @click="animateOptionsOut(); $emit('edit', palette.id    )">
                <icon-pencil/>
            </button>
            <button title="Duplicate" @click="toggleOptions(); $emit('duplicate')">
                <icon-duplicate/>
            </button>
            <button title="Share" @click="toggleShareLink(); $emit('share')">
                <icon-share/>
            </button>
            <button class="delete-button" title="Delete Palette" @click="toggleOptions(); clickOffHandler.removeListener(); $emit('delete');">
                <icon-trash/>
            </button>
            <div class="share-link">
                <share-url :palette="palette"/>
            </div>
        </div>
        <button :class="['options-button', { 'options-visible' : optionsVisible }]" :title="optionsButtonTitle" @click="toggleOptions">
            <div class="dots">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="close-x">
                <span></span>
                <span></span>
            </div>
        </button>
    </div>
</template>

<script>
    import IconPencil    from "../../../../../Lib/Icons/IconPencil";
    import IconDuplicate from "../../../../../Lib/Icons/IconDuplicate";
    import IconShare     from "../../../../../Lib/Icons/IconShare";
    import IconTrash       from "../../../../../Lib/Icons/IconTrash";
    import ShareUrl        from "../../../../../App/Views/Components/ShareUrl.vue";
    import ConfirmDialogue from "../../../../../App/Views/Components/ConfirmDialogue";
    import ClickOffHandler from "../../../../../Lib/helpers/ClickOffHandler";

    export default {
        name      : "PaletteOptions",

        components: {
            IconTrash,
            IconShare,
            IconDuplicate,
            IconPencil,
            ShareUrl,
            ConfirmDialogue,
        },

        props     : {
            palette: {},
        },

        data() {
            return {
                optionsVisible  : false,
                shareLinkVisible: false,
                clickOffHandler : null,
            }
        },

        computed  : {
            optionsSelector() {
                return "#palette-options-" + this.palette.id + " .palette-options";
            },
            shareLinkSelector() {
                return this.optionsSelector + ' .share-link';
            },
            optionsButtonSelector() {
                return "#palette-options-" + this.palette.id + " .options-button";
            },
            optionsButtonTitle() {
                return this.optionsVisible ? 'Close' : 'Palette Options';
            }
        },

        methods   : {
            toggleOptions() {
                this.optionsVisible = !this.optionsVisible;
                this.optionsVisible ? this.animateOptionsIn() : this.animateOptionsOut();
            },


            setOptionsHidden() {
                this.optionsVisible = false;
            },

            toggleShareLink() {
                this.shareLinkVisible = !this.shareLinkVisible;

                this.shareLinkVisible ? this.animateShareLinkIn() : this.animateShareLinkOut();
            },

            animateOptionsIn() {
                TweenMax.fromTo(this.optionsSelector, 0.3, {
                    autoAlpha: 0,
                    right    : "-8rem",
                    ease     : Power4.ease,
                }, {
                    autoAlpha: 1,
                    right    : "4rem",
                });
            },

            animateOptionsOut() {
                this.animateShareLinkOut();

                TweenMax.fromTo(this.optionsSelector, 0.3, {
                    autoAlpha: 1,
                    right    : "4rem",
                    ease     : Power4.ease,
                }, {
                    autoAlpha : 0,
                    right     : "-8rem",
                    onComplete: this.setOptionsHidden,
                });
            },

            animateShareLinkIn() {
                TweenMax.fromTo(this.shareLinkSelector, 0.25, {
                    autoAlpha: 0,
                    right    : "-8rem",
                    ease     : Power4.ease,
                }, {
                    autoAlpha: 1,
                    right    : "0",
                });
            },

            animateShareLinkOut() {
                TweenMax.to(this.shareLinkSelector, 0.25, {
                    autoAlpha : 0,
                    right     : "-8rem",
                    onComplete: this.setShareLinkHidden,
                });
            },

            setShareLinkHidden() {
                this.shareLinkVisible = false;
            },
        },

        mounted() {
            this.clickOffHandler = new ClickOffHandler(this.optionsButtonSelector, () => {
                if(this.optionsVisible) {
                    this.toggleOptions();
                }
            }, this.optionsSelector);
        }
    }
</script>

<style scoped>

</style>